// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3wwc4","label":"Category_label__1dPpy","content":"Category_content__4el28","header":"Category_header__fKXT5","location":"Category_location__GbYxa"};